<template>
  <div>
    <div class="block">
      <div class="block-header block-header-default">
        <h3 class="block-title">
          {{ translate[lang]["customizeoffer"] }}
          <small>
            |
            {{
              parseJSONSupplierName(propositionTitleArr, lang) +
                " - " +
                parseJSONSupplierName(propositionNameArr, lang)
            }}
          </small>
        </h3>
      </div>
      <div class="block-content">
        <div class="table-responsive">

          <div
              v-for="(pitem, key) in products"
              :key="key"
          >

          <table
            class="
              js-table-checkable
              table table-hover table-vcenter
              js-table-checkable-enabled
            "
            v-if="
                combinations[pitem.group] &&
                  combinations[pitem.group].customizedoffer &&
                  selectedProducts.includes(pitem.id)
              "
          >

            <thead>
              <tr>
                <th width="40%" class="d-sm-table-cell">
                  {{ pitem.name[lang] }}
                </th>

                <th width="20%" class="d-sm-table-cell">
                  {{ translate[lang]["basedon"] }}
                </th>
                <th class="d-sm-table-cell">{{ translate[lang]["rate"] }}</th>
                <th width="20%" class="d-sm-table-cell text-right">
                  {{ translate[lang]["permonth"] }}
                </th>
                <th width="20%" class="d-sm-table-cell text-right">
                  {{ translate[lang]["peryear"] }}
                </th>
              </tr>
            </thead>
            <tbody
              v-if="
                combinations[pitem.group] &&
                  combinations[pitem.group].customizedoffer &&
                  selectedProducts.includes(pitem.id)
              "
            >
              <RatesTableTrx
                :product="pitem.id"
                :offer="customizeOffer[pitem.group]"
                :proposition="getProposition()"
                :group="pitem.group"
                :id="pitem.id"
                :name="pitem.name[lang]"
              ></RatesTableTrx>
            </tbody>


          </table>

          </div>

          <table
            class="
              js-table-checkable 22
              table table-hover table-vcenter
              js-table-checkable-enabled
            "
            v-if="
              rates &&
                rates.cashbacks &&
                rates.cashbacks.length > 0 &&
                rates.cashbacks.filter(
                  x => x.proposition_id == getProposition()
                ).length > 0 &&
                ((combinations['electricity'] &&
                  combinations['electricity'].customizedoffer &&
                  selectedProducts.includes(1)) ||
                  (combinations['gas'] &&
                    combinations['gas'].customizedoffer &&
                    selectedProducts.includes(2)))
            "
          >
            <thead>
              <tr>
                <th width="55%" class="d-sm-table-cell">
                  {{ translate[lang]["Discounts"] }}
                </th>
                <th width="20%" class="d-sm-table-cell">
                  {{ translate[lang]["basedon"] }}
                </th>
                <th class="d-sm-table-cell">{{ translate[lang]["rate"] }}</th>
                <th width="70%" class="d-sm-table-cell text-right">
                  {{ translate[lang]["peryear"] }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style="white-space: nowrap; overflow-x: auto">
                <td>
                  <span class="">{{ translate[lang]["Cashback"] }} </span>
                </td>
                <td></td>
                <td>
                  <span class="">
                    {{
                      rates.cashbacks.filter(
                        x => x.proposition_id == getProposition()
                      ).length > 0
                        ? "€ " +
                          rates.cashbacks.filter(
                            x => x.proposition_id == getProposition()
                          )[0].tarief
                        : ""
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span class="">
                    {{
                      rates.cashbacks.filter(
                        x => x.proposition_id == getProposition()
                      ).length > 0
                        ? "€ " +
                          rates.cashbacks.filter(
                            x => x.proposition_id == getProposition()
                          )[0].per_yer_incl_vat
                        : ""
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="block-header block-header-default" v-if="!ratesloader">
        <h3 class="block-title">
          <span>
            {{ translate[lang]["customizesubtitle1"] }}: €
            {{ formatPrice(filterOverview(totalID).yearly) }}
          </span>

          <small style="white-space: nowrap">
            | {{ translate[lang]["customizesubtitle2"] }}: €
            {{ formatPrice(filterOverview(totalID).total) }}
          </small>

          <br>

          <span class="smallText" v-if="canShowDoubleNetting && !isCrossLeftNetted">

            {{ translate[lang]["netting_info"] }}<br>
            {{ translate[lang]["doublerates_normal"] }}: {{tempCustomizeOffer.consumption.high}} kWh - {{(tempCustomizeOffer.solar.high > tempCustomizeOffer.consumption.high) ? tempCustomizeOffer.consumption.high : tempCustomizeOffer.solar.high}} kWh = {{((tempCustomizeOffer.consumption.high - tempCustomizeOffer.solar.high) > 0 ? (tempCustomizeOffer.consumption.high - tempCustomizeOffer.solar.high) : 0)}} kWh<br>
            {{ translate[lang]["doublerates_low"] }}: {{tempCustomizeOffer.consumption.low}} kWh - {{(tempCustomizeOffer.solar.low > tempCustomizeOffer.consumption.low) ? tempCustomizeOffer.consumption.low : tempCustomizeOffer.solar.low}} kWh = {{Math.max(0, tempCustomizeOffer.consumption.low - tempCustomizeOffer.solar.low)}} kWh<br>
          </span>

          <span class="smallText" v-if="canShowDoubleNetting && isCrossLeftNetted">

            {{ translate[lang]["netting_info"] }}<br>

            <!-- als de totale teruggave hoger is dan het totale verbruik -->
            <template v-if="(parseInt(tempCustomizeOffer.solar.low) + parseInt(tempCustomizeOffer.solar.high)) > (parseInt(tempCustomizeOffer.consumption.high) + parseInt(tempCustomizeOffer.consumption.low))">
            {{ translate[lang]["doublerates_normal"] }}: {{tempCustomizeOffer.consumption.high}} kWh - {{tempCustomizeOffer.consumption.high}} kWh = 0 kWh<br>
            {{ translate[lang]["doublerates_low"] }}: {{tempCustomizeOffer.consumption.low}} kWh - {{tempCustomizeOffer.consumption.low}} kWh = 0 kWh<br>  
           </template>
            <!-- anders -->
            <template v-else>

              <!-- HOOG: als teruggave hoger is dan het verbruik -->
              <template v-if="parseInt(tempCustomizeOffer.solar.high) > parseInt(tempCustomizeOffer.consumption.high)">
                {{ translate[lang]["doublerates_normal"] }}: {{tempCustomizeOffer.consumption.high}} kWh - {{tempCustomizeOffer.consumption.high}} kWh = 0 kWh<br>
                
                {{ translate[lang]["doublerates_low"] }}: {{tempCustomizeOffer.consumption.low}} kWh 
                - {{ parseInt(tempCustomizeOffer.solar.low) + (parseInt(tempCustomizeOffer.solar.high) - parseInt(tempCustomizeOffer.consumption.high)) }} kWh 
                = {{parseInt(tempCustomizeOffer.consumption.low) - (parseInt(tempCustomizeOffer.solar.low) + (parseInt(tempCustomizeOffer.solar.high) - parseInt(tempCustomizeOffer.consumption.high))) }} kWh<br>
              </template>
              <!-- anders -->
              <template v-else-if="parseInt(tempCustomizeOffer.solar.low) > parseInt(tempCustomizeOffer.consumption.low)">

                {{ translate[lang]["doublerates_normal"] }}: {{tempCustomizeOffer.consumption.high}} kWh 
                - {{ parseInt(tempCustomizeOffer.solar.high) + (parseInt(tempCustomizeOffer.solar.low) - parseInt(tempCustomizeOffer.consumption.low)) }} kWh 
                = {{parseInt(tempCustomizeOffer.consumption.high) - (parseInt(tempCustomizeOffer.solar.high) + (parseInt(tempCustomizeOffer.solar.low) - parseInt(tempCustomizeOffer.consumption.low))) }} kWh<br>
                
                {{ translate[lang]["doublerates_low"] }}: {{tempCustomizeOffer.consumption.low}} kWh - {{tempCustomizeOffer.consumption.low}} kWh = 0 kWh<br>  
              </template>
              <template v-else>

                {{ translate[lang]["doublerates_normal"] }}: {{tempCustomizeOffer.consumption.high}} kWh - {{(tempCustomizeOffer.solar.low > tempCustomizeOffer.consumption.high) ? tempCustomizeOffer.consumption.high : tempCustomizeOffer.solar.low }} kWh = {{Math.max(0, tempCustomizeOffer.consumption.high - tempCustomizeOffer.solar.low)}} kWh<br>
                {{ translate[lang]["doublerates_low"] }}: {{tempCustomizeOffer.consumption.low}} kWh - {{(tempCustomizeOffer.solar.high > tempCustomizeOffer.consumption.low) ? tempCustomizeOffer.consumption.low : tempCustomizeOffer.solar.high}} kWh = {{Math.max(0, tempCustomizeOffer.consumption.low - tempCustomizeOffer.solar.high)}} kWh<br>
              </template>
            </template>
            
          </span>

          <span class="smallText" v-if="canShowSingleNetting">

            <template v-if="meter == 2">

            {{ translate[lang]["netting_info"] }}<br>
            {{ translate[lang]["singlerates"] }}: {{tempCustomizeOffer.consumption.single}} kWh - {{((tempCustomizeOffer.solar.single > tempCustomizeOffer.consumption.single) ? tempCustomizeOffer.consumption.single : tempCustomizeOffer.solar.single)}} kWh = {{Math.max(0, tempCustomizeOffer.consumption.single - tempCustomizeOffer.solar.single)}} kWh<br>
            </template>
            <template v-else>

                {{nettingSmartSingleRates}}

              <!-- {{ translate[lang]["singlerates"] }}: {{tempCustomizeOffer.consumption.single}} kWh - {{((tempCustomizeOffer.solar.single > tempCustomizeOffer.consumption.single) ? tempCustomizeOffer.consumption.single : tempCustomizeOffer.solar.single)}} kWh = {{Math.max(0, tempCustomizeOffer.consumption.single - tempCustomizeOffer.solar.single)}} kWh<br> -->
            </template>
          </span>

          {{ this.calcSuperTotal() }}

        </h3>
      </div>


    </div>
    <!-- customize offer/for energie block start -->

    <div class="block">
      <div class="block-header block-header-default">
        <h3 class="block-title">{{ translate[lang]["collaps"] }}</h3>
        <div class="block-options">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="content_toggle"
          >
            <i class="si si-arrow-up"></i>
          </button>
        </div>
      </div>
      <div class="block-content" v-html="translate[lang]['explanationpricestructure']"></div>
    </div>
    <!-- cutomize offer/for energie block end -->

    <personal-preferences v-if="!this.$route.query.makeCalcReady"/>

  </div>
</template>

<script>
import { mapState } from "vuex";
import PersonalPreferences from '../PersonalPreferences.vue';
import RatesTableTrx from "./include/RatesTableTrx";
export default {
  name: "RatesTable",
  data() {
    return {
      propositionTitle: "",
      propositionTitleArr: "",
      propositionNameArr: "",
      enum: {
        consumptionKnow: "1",
        consumptionNotKnow: "2"
      },
      customizeOffer: {
        electricity: {
          single: null,
          double: {
            low: null,
            high: null
          },
          supply: {
            single: null,
            double: {
              low: null,
              high: null
            }
          }
        },
        gas: null
      },
      tempCustomizeOffer: {
        consumption: {
          single: "0",
          low: "0",
          high: "0",
          gas: "0"
        },
        solar: {
          single: "0",
          low: "0",
          high: "0"
        }
      },
      totalID: 0
    };
  },
  components: { RatesTableTrx, PersonalPreferences },
  computed: {
    ...mapState({
      energyTotal: (state) => state.forms.pricing.energy_total,
      gasTotal: (state) => state.forms.pricing.gas_total,
      combinations: state => state.forms.combinations,
      solar: state => state.forms.solar,
      consumption: state => state.forms.consumption,
      ratesloader: state => state.forms.ratesloader,
      familySituation: state => state.forms.consumption.familySituation,
      consumptionStatus: state => state.forms.consumption.status,
      consumptions: state => state.forms.consumptions,
      meter: (state) => state.forms.meter,
      smartMeter: (state) => state.forms.smartMeter,
      canShowSingleNetting() {
        return this.solar.status == 1 && this.meter == 1 && this.tempCustomizeOffer.solar.single > 0
      },
      canShowDoubleNetting() {
        return this.solar.status == 1 && this.meter == 2 && (this.tempCustomizeOffer.solar.high > 0 || this.tempCustomizeOffer.solar.low > 0)
      },
      nettingSmartSingleRates() {

        let consumption = 0;
        let solar = 0;

        if(this.smartMeter == 1) {
           consumption = (parseInt(this.tempCustomizeOffer.consumption.high) + parseInt(this.tempCustomizeOffer.consumption.low));
           solar = (parseInt(this.tempCustomizeOffer.solar.low) + parseInt(this.tempCustomizeOffer.solar.high));
        } else {
           consumption = parseInt(this.tempCustomizeOffer.consumption.single);
           solar = parseInt(this.tempCustomizeOffer.solar.single);
        }

      if (solar > consumption) {
        solar = consumption;
      }

      var difference = Math.max(0, consumption - solar);

      return this.translate[this.lang]["singlerates"] + ': ' + consumption + ' kWh - ' + solar + ' kWh = ' + difference + ' kWh';
    },
      isCrossLeftNetted() {
        if (this.meter == 2) {
          var high = parseInt(this.consumption.electric.double.high) - parseInt(this.solar.high);
          var low = parseInt(this.consumption.electric.double.low) - parseInt(this.solar.low);
          if (high > 0 && low < 0 || low > 0 && high < 0) {
            return true;
          }
        }
        return false;
      },
    })
  },
  methods: {

    calcSuperTotal() {
      if (this.checkElectricGas) {

        let yearlyTotal = (parseFloat(this.energyTotal) + parseFloat(this.gasTotal))
        this.filterOverview(6).yearly = yearlyTotal;
        this.filterOverview(6).total = yearlyTotal / 12;
      } else if (!this.checkElectricGas && this.filterOverview(1)) {

        let yearlyTotal = parseFloat(this.energyTotal)
        this.filterOverview(1).yearly = yearlyTotal;
        this.filterOverview(1).total = yearlyTotal / 12;

      } else if (!this.checkElectricGas && this.filterOverview(2)) {

        let yearlyTotal = parseFloat(this.gasTotal)
        this.filterOverview(2).yearly = yearlyTotal;
        this.filterOverview(2).total = yearlyTotal / 12;

      }

    },

    setCustomizeOffer() {
      //consumption
      if (this.consumptionStatus == 2) {
        let currentConsumption = this.consumptions.filter(
          x => x.id == this.familySituation
        )[0];
        if (currentConsumption) {
          (this.tempCustomizeOffer.consumption.single =
            currentConsumption.electric.single),
            (this.tempCustomizeOffer.consumption.low =
              currentConsumption.electric.double.low),
            (this.tempCustomizeOffer.consumption.high =
              currentConsumption.electric.double.high);
          this.tempCustomizeOffer.consumption.gas = currentConsumption.gas;
        }
      } else {
        (this.tempCustomizeOffer.consumption.single = this.parseValue(
          this.consumption.electric.single
        )),
          (this.tempCustomizeOffer.consumption.low = this.parseValue(
            this.consumption.electric.double.low
          )),
          (this.tempCustomizeOffer.consumption.high = this.parseValue(
            this.consumption.electric.double.high
          )),
          (this.tempCustomizeOffer.consumption.gas = this.parseValue(
            this.consumption.gas
          ));
      }

      //solars
      if (this.solar.status == 1 && this.solar.kwhKnown == 2) {
        let currentSolars = this.solars.filter(
          x => x.id === parseInt(this.solar.number_of_panels)
        )[0];
        if (currentSolars) {
          (this.tempCustomizeOffer.solar.single = currentSolars.single),
            (this.tempCustomizeOffer.solar.low = currentSolars.low),
            (this.tempCustomizeOffer.solar.high = currentSolars.high);
        }
      } else if (this.solar.status == 1 && this.solar.kwhKnown == 1) {
        (this.tempCustomizeOffer.solar.single = this.solar.single),
          (this.tempCustomizeOffer.solar.low = this.solar.low),
          (this.tempCustomizeOffer.solar.high = this.solar.high);
      } else if (this.solar.status == 2) {
        (this.tempCustomizeOffer.solar.single = 0),
          (this.tempCustomizeOffer.solar.low = 0),
          (this.tempCustomizeOffer.solar.high = 0);
      }
      
      if (this.tempCustomizeOffer.consumption.single - this.tempCustomizeOffer.solar.single < 0) {
        this.customizeOffer.electricity.single = 0;
      } else {
      this.customizeOffer.electricity.single =
        this.tempCustomizeOffer.solar.single >
        this.tempCustomizeOffer.consumption.single
          ? 0
          : this.tempCustomizeOffer.consumption.single -
            this.tempCustomizeOffer.solar.single;
      }

      this.customizeOffer.electricity.supply.single =
        this.tempCustomizeOffer.consumption.single -
        this.tempCustomizeOffer.solar.single;

      if (this.isCrossLeftNetted) {

      this.customizeOffer.electricity.supply.double.low =
        this.tempCustomizeOffer.consumption.low -
        this.tempCustomizeOffer.solar.high;

      this.customizeOffer.electricity.supply.double.high =
        this.tempCustomizeOffer.consumption.high -
        this.tempCustomizeOffer.solar.low;

        this.customizeOffer.electricity.double.low =
        this.tempCustomizeOffer.solar.low >
        this.tempCustomizeOffer.consumption.low
          ? 0
          : this.tempCustomizeOffer.consumption.low -
            this.tempCustomizeOffer.solar.high;

      this.customizeOffer.electricity.double.high =
        this.tempCustomizeOffer.solar.high >
        this.tempCustomizeOffer.consumption.high
          ? 0
          : this.tempCustomizeOffer.consumption.high -
            this.tempCustomizeOffer.solar.low;

      } else {

      this.customizeOffer.electricity.supply.double.low =
        this.tempCustomizeOffer.consumption.low -
        this.tempCustomizeOffer.solar.low;

      this.customizeOffer.electricity.supply.double.high =
        this.tempCustomizeOffer.consumption.high -
        this.tempCustomizeOffer.solar.high;

        this.customizeOffer.electricity.double.low =
        this.tempCustomizeOffer.solar.low >
        this.tempCustomizeOffer.consumption.low
          ? 0
          : this.tempCustomizeOffer.consumption.low -
            this.tempCustomizeOffer.solar.low;

      this.customizeOffer.electricity.double.high =
        this.tempCustomizeOffer.solar.high >
        this.tempCustomizeOffer.consumption.high
          ? 0
          : this.tempCustomizeOffer.consumption.high -
            this.tempCustomizeOffer.solar.high;

      }

      

      this.customizeOffer.gas = parseInt(
        this.tempCustomizeOffer.consumption.gas
      );

      // }
      this.$store.state.forms.customizedOffers = this.customizeOffer;
    },
    parseValue(value) {
      return !parseInt(value) ? 0 : parseInt(value);
    },
    getProposition() {
      let group = "";

      if (this.selectedProducts.includes(1) && !this.checkElectricGas) {
        group = "electricity";
        this.totalID = 1;
      } else if (this.selectedProducts.includes(2) && !this.checkElectricGas) {
        group = "gas";
        this.totalID = 2;
      } else if (this.checkElectricGas) {
        group = "electricityandgas";
        this.totalID = 6;
      }

      let defaultProp = this.getGroupArray(group).filter(
        x => x.type === "suppliers"
      )[0].default;
      let defaultPropDetail = this.getGroupArray(group)
        .filter(x => x.type === "suppliers")[0]
        .suppliers.filter(y => y.id === defaultProp)[0];
      this.propositionTitleArr = defaultPropDetail.title;
      this.propositionNameArr = defaultPropDetail.name;
      this.propositionTitle =
        defaultPropDetail.title + " - " + defaultPropDetail.name;
      return defaultProp;
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    }
  },
  created() {
    this.setCustomizeOffer();
  },

  watch: {
    solar: {
      handler: function() {
        if (this.selectedProducts.includes(1)) {
          this.setCustomizeOffer();
        }
      },
      deep: true
    },
    consumption: {
      handler: function() {
        this.setCustomizeOffer();
      },
      deep: true
    },
    consumptions: {
      handler: function() {
        this.setCustomizeOffer();
      },
      deep: true
    },
    solars: {
      handler: function() {
        this.setCustomizeOffer();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
#prcStrctrList {
  padding-left: 1.33em;
}

.smallText {
  display: block;font-size: small;
}
</style>